<template>
  <div class="header-container pt-1">
    <header class="has-background-white widget-header">
      <div class="mobile-home-logo">
        <widget-home-logo class="endpoints"/>
        <widget-header-home class="mobile-home-button"/>
      </div>
      <div class="desktop-home-logo">
        <widget-home-logo class="endpoints"/>
      </div>
      <widget-global-search-bar :input="input"
                                :isExactMatch="isExactMatch"
                                @updateExactMatch="updateExactMatch"
                                @updateInput="updateInput" />
      <widget-header-home class="desktop-home-button"/>
    </header>
    <announcement-banner />
  </div>
</template>

<script setup>
import AnnouncementBanner from '@/components/common/announcement/AnnouncementBanner.vue'
import WidgetGlobalSearchBar from './WidgetGlobalSearchBar'
import WidgetHeaderHome from './WidgetHeaderHome'
import WidgetHomeLogo from './WidgetHomeLogo'

const emit = defineEmits(['updateExactMatch', 'updateInput'])
const props = defineProps({
    input: {
      type: String,
      required: true
    },
    isExactMatch: {
      type: String,
      required: false
    }
  })

  const updateInput = (value) => {
    emit('updateInput', value)
  }

  const updateExactMatch = (value) => {
    emit('updateExactMatch', value)
  }

</script>

<style lang="scss" scoped>
  .endpoints {
    min-width: 5rem;
    min-height: 2rem;
    float: left;
  }
  .widget-container {
    @media screen and (max-width: 640px) {
      margin-bottom: 1em;
    }
  }
  .widget-header {
    @media screen and (min-width: 641px) {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  header {
    position: sticky;
    top: 0;
    z-index: 40;
  }
  .mobile-home-logo {
    @media screen and (min-width: 639px) {
      display: none;
    }
    display: inline-block;
  }
  .desktop-home-logo {
    @media screen and (max-width: 640px) {
      display: none;
    }
  }
  .mobile-home-button {
    position: absolute;
    right: 0
  }
  .desktop-home-button {
    @media screen and (max-width: 640px) {
      display: none;
    }
    float: right;
  }
</style>
